module.exports = __webpack_public_path__ + "static/media/MyriadProBold.5468e8ae.ttf";